import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap5";

export default class extends Controller {
  static targets = [
    "dollars",
    "plays",
    "slider",
    "modalPlays",
    "modalDollars",
    "btn",
    "wbtn",
  ];
  static values = {
    ppp: Number,
  };
  // ppp => price_per_play

  connect() {
    this.initSlider();
//    console.log("btn", this.wbtnTarget);
  }

  confirmModal(event) {
    event.preventDefault();
    console.log("confirm!");
    $(this.modalPlaysTarget).text($(this.playsTarget).text());
    $(this.modalDollarsTarget).text($(this.dollarsTarget).val());

    Modal.getOrCreateInstance("#boost_confirm_modal").show();
    return false;
  }

  submit() {
    Turbo.navigator.submitForm($("#boost_form_el")[0]);
    $(this.btnTargets).addClass("d-none");
    $(this.wbtnTarget).removeClass("d-none");

    //    $("#boost_form")[0].requestSubmit();
    //   Modal.getOrCreateInstance("#boost_confirm_modal").hide();
  }

  initSlider() {
    $(this.sliderTarget).ionRangeSlider({
      onStart: (data) => {
        $(this.dollarsTarget).val(data.from);
        $(this.playsTarget).html(Math.ceil(data.from / this.pppValue));
        $(".irs-min").hide();
      },
      onChange: (data) => {
        $(this.dollarsTarget).val(data.from);
        $(this.playsTarget).html(Math.ceil(data.from / this.pppValue));
      },
      onUpdate: (data) => {
        $(this.dollarsTarget).val(data.from);
        $(this.playsTarget).html(Math.ceil(data.from / this.pppValue));
        $(".irs-min").hide();
      },
    });

    this.sliderInstance = $(this.sliderTarget).data("ionRangeSlider");

    $(this.dollarsTarget).on("input", (event) => {
      var val = $(event.target).val();

      //console.log("inputing", val, this.sliderInstance.options.from_min);

      if (val == "" || parseInt(val) < this.sliderInstance.options.from_min) {
        console.log("return");
        return false;
      }

      val = this.validate(parseInt(val));

      this.sliderInstance.update({
        from: val,
      });
    });

    $(this.dollarsTarget).on("blur", (event) => {
      var val = $(event.target).val();

      val = this.validate(parseInt(val));

      this.sliderInstance.update({
        from: val,
      });
    });
  }

  validate(val) {
    if (val < this.sliderInstance.options.from_min) {
      return this.sliderInstance.options.from_min;
    } else if (val > this.sliderInstance.options.max) {
      return this.sliderInstance.options.max;
    }

    return val;
  }

  incr() {
    var val = this.validate(parseInt($(this.dollarsTarget).val()) + 1);
    this.sliderInstance.update({
      from: val,
    });
    // $(this.dollarsTarget).val(val)
  }

  decr() {
    var val = this.validate(parseInt($(this.dollarsTarget).val()) - 1);
    this.sliderInstance.update({
      from: val,
    });
    //  $(this.dollarsTarget).val(val)
  }

  disconnect() {
    $(this.dollarsTarget).off();
    this.sliderInstance.destroy();
  }
}
